"use client";

import cx from "classnames";
import React from "react";

import styles from "./button.module.scss";

type Props = React.PropsWithChildren<{
  onClick?: () => void;
  className?: string;
}>;

const Button: React.FC<Props> = ({ className, ...props }) => {
  const rootClassName = cx(styles.root, className);
  return <button {...props} className={rootClassName} />;
};

export default Button;
